@if (message) {
  <div [class]="level + ' base'" [innerHtml]="message"></div>
}
